import React from "react";
import Label from "components/general/Label"
import { findArray, arraysEqual } from 'helpers/utils'
import { useViewport } from 'components/general/useViewPort'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import SjpExpandedDefault from "components/sports/sjp/helper/SjpExpandedDefault";
import SportCode from 'components/common/SportCode'


export const TableExpanded = React.memo((props) => {
    const { row } = props;
    const { officials } = props;
    const { mirs_discipline, mirs_event_rsc } = useUrlFriendlyToParameters()

    let trial = mirs_event_rsc.includes('FNL-TR') || mirs_event_rsc.includes('QUALTR') 
    let training = mirs_event_rsc.includes('TRNO01') || mirs_event_rsc.includes('TRNO02')|| mirs_event_rsc.includes('TRNO03')

    let distance,speed,gate,gatePoints,gateChange,wind,compensationPoints,totalPoints,rank = ''
    if(row?.resultType === 'POINTS')
    {
        distance = findArray(row?.extendedResults, { er_code: ['DIST'] })
        speed = findArray(row?.extendedResults, { er_code: ['SPEED'] })?.er_value
        gate = findArray(row?.extendedResults, { er_code: ['GATE_NUM'] })?.er_value
        gatePoints = findArray(row?.extendedResults, { er_code: ['GATE_NUM'] })?.er_value2
        gateChange = row?.extendedResultsCurrent?.find(i => i?.er_code === 'GATE_NUM')?.extensions?.find(i => i?.ere_code === 'GATE_CHANGE')?.ere_value
        wind = findArray(row?.extendedResults, { er_code: ['WIND_SPEED'] })
        compensationPoints = findArray(row?.extendedResults, { er_code: ['TOT'] })?.er_value
        totalPoints = row?.resultData
        rank = row?.resultRank
    }

    let judges = []
    let f = 0
    officials.map((i) => {
        if(i?.function?.description === 'Judge')
        {
            judges[f++] = i
        }
    })

    return (
        <>
            {(trial || training)
                ?
                    <>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderDistance" /></th>
                                </tr>
                                <tr>
                                    <th className="text-center w-30" scope="row"><Label data="HeaderDistanceM" sport={mirs_discipline} /></th>
                                    <td>
                                    {row?.resultType === 'IRM'
                                        ? <SportCode discipline={mirs_discipline} entity='@IRM' code={row?.resultIrm} abbr={true} />
                                        : row?.resultIrm === 'IRF'
                                            ? <SportCode discipline={mirs_discipline} entity='@IRF' code={row?.resultIrm} abbr={true} />
                                            : row?.resultType === 'POINTS'
                                                ? distance?.er_value
                                                : ''
                                    }
                                    </td>
                                </tr>
                                <tr>
                                    <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderDistancePoints" sport={mirs_discipline} /></th>
                                    <td className="fw-bold">{distance?.er_value2}</td>
                                </tr>
                                <tr>
                                    <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderSpeedKmH" sport={mirs_discipline}/></th>
                                    <td className="fw-bold">{speed}</td>
                                </tr>
                                <tr>
                                    <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderCompensation" /></th>
                                </tr>
                                <tr>
                                    <th className="text-center w-30" scope="row"><Label data="HeaderGate" /></th>
                                    <td>{gate}&ensp;
                                    {gateChange === 'C'
                                        ? <Label data="HeaderCoachDecision" sport={mirs_discipline} />
                                        : ''
                                    }
                                    </td>
                                </tr>
                                <tr>
                                    <th className="text-center w-30" scope="row"><Label data="HeaderGatePoints" sport={mirs_discipline} /></th>
                                    <td>{gatePoints}</td>
                                </tr>
                                <tr>
                                    <th className="text-center w-30" scope="row"><Label data="HeaderWindMS" sport={mirs_discipline} /></th>
                                    <td>{wind?.er_value}</td>
                                </tr>
                                <tr>
                                    <th className="text-center w-30" scope="row"><Label data="HeaderWindPoints" sport={mirs_discipline} /></th>
                                    <td>{wind?.er_value2}</td>
                                </tr>
                                <tr>
                                    <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderCompensationPoints" sport={mirs_discipline} /></th>
                                    <td className="fw-bold">{compensationPoints}</td>
                                </tr>
                                <tr>
                                    <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderTotalPoints" /></th>
                                    <td className="fw-bold">{totalPoints}</td>
                                </tr>
                                <tr>
                                    <th className="text-center w-30 fw-bold" scope="row"><Label data="HeaderRank" /></th>
                                    <td className="fw-bold">{rank}</td>
                                </tr>
                            </thead>
                        </table>
                    </>
                : <SjpExpandedDefault row={row} extendedResults={row?.extendedResults} judges={judges}/>
            }
        </>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    console.log(arraysEqual(prevProps.row.extendedResults, nextProps.row.extendedResults))
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row.extendedResults, nextProps.row.extendedResults)
    )
});